import React from "react";
import Footer from "../components/Footer";

function GlobalMarket() {
  return (
    <section className="p-content">
      <div className="ctr">
        <h1 className="global-office">Global Offices</h1>
        <p className="global-office">
          Below is a list of official IMD International Search Group partners.
          If you have recruitment needs in other countries or regions, please
          reach out to us :<br /> Some of our members work beyond their
          frontiers; Besides, we have a network of reliable contacts throughout
          the world.
        </p>
      </div>
      <div className="container py-5">
        <div className="row city-img"></div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <article>
              <h3>
                <img
                  src="/assets/img/flags/i-australia.png"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/australia/"
                  className="countries"
                >
                  AUSTRALIA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/australia/melbourne/">
                    Melbourne
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/australia/sydney/">
                    Sydney
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/australia/brisbane/">
                    Brisbane
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-belgium.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/belgium"
                  className="countries"
                >
                  BELGIUM
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/belgium/antwerp">
                    Antwerp
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/belgium/brussels">
                    Brussels
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/belgium/ghent">
                    Ghent
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-brazil.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/brazil"
                  className="countries"
                >
                  BRAZIL
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/brazil/sao-paulo">
                    São Paulo
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-canada.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/canada"
                  className="countries"
                >
                  CANADA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/canada/toronto">
                    Toronto
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/canada/montreal">
                    Montreal
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-chile.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/chile"
                  className="countries"
                >
                  CHILE
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/chile/santiago">
                    Santiago
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/ch-lgflag.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/china"
                  className="countries"
                >
                  CHINA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/china/china/">
                    Shanghai
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/cz.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/czech-republic"
                  className="countries"
                >
                  CZECH REPUBLIC
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/czech-republic/prague">
                    Prague
                  </a>
                </li>
              </ul>
            </article>
          </div>

          <div className="col-lg-3 col-md-4">
            <article>
              <h3>
                <img src="/assets/img/flags/i-denmark.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/denmark"
                  className="countries"
                >
                  DENMARK
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/denmark/copehangen/">
                    Copenhagen
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-finland.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/finland"
                  className="countries"
                >
                  FINLAND
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/finland/helsinki">
                    Helsinki
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-france.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/france"
                  className="countries"
                >
                  FRANCE
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/france/paris">
                    Paris
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-germany.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/germany"
                  className="countries"
                >
                  GERMANY
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/germany/stuttgart">
                    Stuttgart
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/germany/frankfurt/">
                    Dresden
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/germany/dusseldorf/">
                    Düsseldorf
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/germany/berlin">
                    Berlin
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/hu-lgflag.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/hungary"
                  className="countries"
                >
                  HUNGARY
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/hungary/budapest1/">
                    Budapest
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/in-flag.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/india"
                  className="countries"
                >
                  INDIA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/india/new-delhi">
                    New Delhi
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/india/bangalore">
                    Bangalore
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-italy.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/italy"
                  className="countries"
                >
                  ITALY
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/italy/milan">
                    Milan
                  </a>
                </li>
              </ul>
            </article>
          </div>

          <div className="col-lg-3 col-md-4">
            <article>
              <h3>
                <img src="/assets/img/flags/i-mexico.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/mexico"
                  className="countries"
                >
                  MEXICO
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/mexico/mexico_city1/">
                    Mexico City
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/mexico/guadalajara1/">
                    Guadalajara
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/mexico/monterrey">
                    Monterrey
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img
                  src="/assets/img/flags/i-netherlands.png"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/netherlands"
                  className="countries"
                >
                  NETHERLANDS
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/netherlands/amsterdam">
                    Amsterdam
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/netherlands/s-hertogenbosch">
                    ‘s-Hertogenbosch
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img
                  src="/assets/img/flags/i-new-zealand.png"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/new-zealand"
                  className="countries"
                >
                  NEW ZEALAND
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/new-zealand/auckland">
                    Auckland
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-norway.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/norway"
                  className="countries"
                >
                  NORWAY
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/norway/oslo">
                    Oslo
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-poland.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/poland"
                  className="countries"
                >
                  POLAND
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/poland/warsaw">
                    Warsaw
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img
                  src="/assets/img/flags/serbia-yi-flag.gif"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/serbia"
                  className="countries"
                >
                  SERBIA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/serbia/belgrade">
                    Belgrade
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/sk.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/slovakia"
                  className="countries"
                >
                  SLOVAKIA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/slovakia/bratislava">
                    Bratislava
                  </a>
                </li>
              </ul>
            </article>
          </div>

          <div className="col-lg-3 col-md-4">
            <article>
              <h3>
                <img src="/assets/img/flags/i-spain.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/spain"
                  className="countries"
                >
                  SPAIN
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/spain/madrid">
                    Madrid
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/i-sweden.png" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/sweden"
                  className="countries"
                >
                  SWEDEN
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/sweden/malmo">
                    Malmö
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/sweden/stockholm">
                    Stockholm
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/sweden/goteborg/">
                    Göteborg
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img
                  src="/assets/img/flags/i-switzerland.png"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/switzerland"
                  className="countries"
                >
                  SWITZERLAND
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/switzerland/zurich">
                    Zurich
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img src="/assets/img/flags/ae-flag.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/united-arab-emirates"
                  className="countries"
                >
                  UNITED ARAB EMIRATES
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/united-arab-emirates/dubai">
                    Dubai
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img
                  src="/assets/img/flags/i-united-kingdom.png"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/united-kingdom"
                  className="countries"
                >
                  UNITED KINGDOM
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/united-kingdom/london">
                    London
                  </a>
                </li>
              </ul>
            </article>

            <article>
              <h3>
                <img
                  src="/assets/img/flags/i-united-states.png"
                  className="flags" alt=''
                />
                <a
                  href="https://www.imdsearch.com/about/global-offices/united-states"
                  className="countries"
                >
                  UNITED STATES
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/united-states/boston">
                    Boston
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/united-states/houston1/">
                    Houston
                  </a>
                </li>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/united-states/salt-lake-city">
                    Salt Lake City
                  </a>
                </li>
              </ul>
            </article>
            <article>
              <h3>
                <img src="/assets/img/flags/ro-flag.gif" className="flags" alt='' />
                <a
                  href="https://www.imdsearch.com/about/global-offices/romania/"
                  className="countries"
                >
                  ROMANIA
                </a>
              </h3>
              <ul>
                <li>
                  <a href="https://www.imdsearch.com/about/global-offices/romania/bucharest/">
                    Bucharest
                  </a>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default GlobalMarket;
